export default {
  outList: [
    {
      light_point_1:[
        {
          title: '硬派劲野前脸',
          type: 'image',
          video: '',
          image: 'lightPoint/1/1.jpg',
          text: '极简硬朗轮廓线条搭配矩阵式前格栅和璀璨的天际线日行灯，尽情释放年轻野性'
        },
      ],
      light_point_2:[
        {
          title: '旷野极简车身',
          type: 'image',
          video: '',
          image: 'lightPoint/1/2.jpg',
          text: '高腰线的车身设计，完美的车身比例，纯粹而不简单，让动感的硬派车身，更具精致时尚'
        },
      ],
      light_point_3:[
        {
          title: '潮酷高能尾部',
          type: 'image',
          video: '',
          image: 'lightPoint/1/3.jpg',
          text: '精致与力量兼容的尾部设计，极简有力，贯穿式星河耀目LED尾灯，狂野之中流露出时尚科技感'
        }
      ]
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '8155游玩AI座舱',
          type: 'image',
          video: '',
          image: 'lightPoint/4/1.jpg',
          text: '搭载高通8155芯片、540°高清全景影像、50W手机无线快充等，让你智享每一次旅程'
        }
      ],
      light_point_3:[
        {
          title: '未来超感内饰',
          type: 'image',
          video: '',
          image: 'lightPoint/1/4.jpg',
          text: '一体环抱式未来座舱设计，辅以机甲风的局部造型，简约科技，面向未来'
        }
      ],
      light_point_2:[
        {
          title: '绿色健康座舱',
          type: 'image',
          video: '',
          image: 'lightPoint/4/2.jpg',
          text: '为你带来C-PURE净立方绿色座舱，更有37.6分贝NVH静谧空间，静享健康舒适出行'
        }
      ]
    }
  ],
  tab1:[
    {
      title: '硬派劲野前脸',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '极简硬朗轮廓线条搭配矩阵式前格栅和璀璨的天际线日行灯，尽情释放年轻野性'
    },
    {
      title: '旷野极简车身',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '高腰线的车身设计，完美的车身比例，纯粹而不简单，让动感的硬派车身，更具精致时尚'
    },
    {
      title: '潮酷高能尾部',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '精致与力量兼容的尾部设计，极简有力，贯穿式星河耀目LED尾灯，狂野之中流露出时尚科技感'
    },
    {
      title: '未来超感内饰',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: '一体环抱式未来座舱设计，辅以机甲风的局部造型，简约科技，面向未来'
    }
  ],
  tab2: [
    {
      title: '驾控更安全',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '＜0.1s四驱介入速度，超快响应，后轴最大扭矩3000N·m ，超强脱困，带你纵情山野，奔赴远方'
    },
    {
      title: '高效更节能',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: '鲲鹏1.6TGDI+7DCT超级动力组合，7.48L百公里四驱超低油耗，8秒级零百加速，能驱能省，一路狂飙'
    },
    {
      title: '悦野乐趣多',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '7种四驱驾驶模式，带你探索世界，605mm涉水深度，超优通过性，与你尽享野趣'
    }
  ],
  tab3: [
    {
      title: '领先安全品质',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '达标中国C-NCAP、欧盟Euro-NCAP、东盟ASEAN-NCAP、澳洲A-NCAP、南美LATIN-NCAP等全球一流安全标准'
    }
  ],
  tab4: [
    {
      title: '8155游玩AI座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/4/1.jpg',
      text: '搭载高通8155芯片、540°高清全景影像、50W手机无线快充等，让你智享每一次旅程'
    },
    {
      title: '绿色健康座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/4/2.jpg',
      text: '为你带来C-PURE净立方绿色座舱，更有37.6分贝NVH静谧空间，静享健康舒适出行'
    },
    {
      title: '魔术空间座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/4/3.jpg',
      text: '1338L百变超大后备箱空间，多种分层组合设计，更有魔术纸巾盒超多巧思设计，带来人性化享受'
    }
  ]
}
